var map = {
	"./AppDevelop.jpg": 6480,
	"./BuyukAttentance/Attentance1.jpg": 4763,
	"./BuyukAttentance/Attentance2.jpg": 602,
	"./BuyukAttentance/Attentance3.jpg": 4866,
	"./BuyukCSoftware/cs1.jpg": 9141,
	"./BuyukCSoftware/cs2.jpg": 6,
	"./BuyukCSoftware/cs3.jpg": 5108,
	"./BuyukERP/ERP1.jpg": 5093,
	"./BuyukERP/ERP2.jpg": 5670,
	"./BuyukERP/ERP3.jpg": 5820,
	"./BuyukGPStracking/gps1.jpg": 5414,
	"./BuyukGPStracking/gps2.jpg": 1504,
	"./BuyukGPStracking/gps3.jpg": 498,
	"./BuyukInteractivePanel/panel1.jpg": 6425,
	"./BuyukInteractivePanel/panel2.jpg": 3234,
	"./BuyukInteractivePanel/panel3.jpg": 6442,
	"./BuyukMobileApp/mapp1.jpg": 8201,
	"./BuyukMobileApp/mapp2.jpg": 6292,
	"./BuyukMobileApp/mapp3.jpg": 8247,
	"./BuyukPremiumSupport/premiums1.jpg": 7687,
	"./BuyukPremiumSupport/premiums2.jpg": 5851,
	"./BuyukPremiumSupport/premiums3.jpg": 4617,
	"./BuyukSchoolManagement/SMS1.jpg": 1197,
	"./BuyukSchoolManagement/SMS2.jpg": 4676,
	"./BuyukSchoolManagement/SMS3.jpg": 2308,
	"./BuyukTracking/RealTimeTracking1.jpg": 4829,
	"./BuyukTracking/RealTimeTracking2.jpg": 2660,
	"./BuyukTracking/RealTimeTracking3.jpg": 3211,
	"./BuyukWebApp/webapp1.jpg": 2359,
	"./BuyukWebApp/webapp2.jpg": 6922,
	"./BuyukWebApp/webapp3.jpg": 2892,
	"./BuyukWebdesign/webd1.jpg": 2178,
	"./BuyukWebdesign/webd2.jpg": 5486,
	"./BuyukWebdesign/webd3.jpg": 7650,
	"./Certificates BG.png": 2615,
	"./Certification1.png": 3911,
	"./Certification2.png": 5301,
	"./Certification3.png": 4937,
	"./Certification4.png": 6698,
	"./Certification5.png": 3731,
	"./Certification6.png": 4392,
	"./Customised Software.jpg": 5707,
	"./ERP.jpg": 8570,
	"./Imp bus tracking/image 122.png": 3526,
	"./Imp bus tracking/image 123.png": 2311,
	"./Imp bus tracking/image 124.png": 5415,
	"./Imp bus tracking/image 125.png": 5632,
	"./Offline Services.jpg": 9776,
	"./Products BG.png": 7813,
	"./Sactin Library.png": 9690,
	"./Sactin Mobile App.png": 523,
	"./WebAppdevelop.jpg": 3080,
	"./about-parrallax1.jpg": 6757,
	"./aboutusbg.jpg": 7575,
	"./aigroup.jpg": 6995,
	"./aigroup2.jpg": 8901,
	"./app.png": 9883,
	"./bg agin again.png": 4757,
	"./bg-image1.jpg": 9125,
	"./biometric front end bg.png": 8807,
	"./biometric/bio1.png": 1339,
	"./biometric/bio2.png": 6363,
	"./biometric/bio3.png": 3235,
	"./biometric/bio4.png": 1856,
	"./biometric/bio5.png": 4913,
	"./biometricvector11.png": 9381,
	"./bus trcking/Featuresicon1.png": 9906,
	"./bus trcking/Featuresicon2.png": 6641,
	"./bus trcking/Featuresicon3.png": 9719,
	"./bus trcking/Featuresicon4.png": 7591,
	"./bus trcking/Featuresicon5.png": 6401,
	"./bus trcking/Featuresicon6.png": 4555,
	"./buyuk-final.jpg": 8485,
	"./buyuk.png": 7890,
	"./buyukLibrary/library1.jpg": 656,
	"./buyukLibrary/library2.jpg": 3985,
	"./buyukLibrary/library3.jpg": 994,
	"./check.png": 3140,
	"./checked.png": 8849,
	"./clients/client 2.jpg": 4788,
	"./clients/client 3.jpg": 2125,
	"./clients/client 4.jpg": 4537,
	"./clients/client 5.jpg": 2123,
	"./clients/client 6.jpg": 8259,
	"./clients/client 7.jpg": 1403,
	"./clients/client1.jpg": 811,
	"./companystory.jpg": 2372,
	"./dgxg.png": 5932,
	"./footer.jpg": 285,
	"./gpstracking lastbg.png": 6410,
	"./gpstrackingbus.png": 4425,
	"./homebg1.jpg": 3123,
	"./homebg2.jpg": 8109,
	"./homebg6.jpg": 1578,
	"./imggif2.gif": 1459,
	"./logo/Group 511.png": 8131,
	"./logo/Group 514.png": 8732,
	"./logo/Group 515.png": 3013,
	"./logo/Group 518.png": 3699,
	"./logo/Group 537.png": 2093,
	"./logo/Group 542.png": 328,
	"./logo/Group 557.png": 465,
	"./logo/Group 558.png": 2548,
	"./logo/Group 559.png": 2164,
	"./logo/Group 560.png": 2865,
	"./logo/Group 561.png": 1985,
	"./logo/Group 563.png": 2325,
	"./logo/Group 571.png": 2682,
	"./logo/Group 573.png": 1185,
	"./logo/Group 579.png": 5302,
	"./logo/Group 584.png": 7609,
	"./logo/Group 587.png": 8046,
	"./logo/Group 592.png": 1471,
	"./logo/Group 593.png": 945,
	"./logo/Group 595.png": 1493,
	"./logo/Group 605.png": 4872,
	"./logo/Group 615.png": 953,
	"./logo/Group 616.png": 4593,
	"./logo/Group 617.png": 5033,
	"./logo/Group 618.png": 1951,
	"./logo/Group 619.png": 9453,
	"./logo/Group 620.png": 2896,
	"./logo/Group 621.png": 1324,
	"./logo/Group 623.png": 9924,
	"./logo/Group 624.png": 1707,
	"./logo/Group 625.png": 1417,
	"./logo/Group 626.png": 957,
	"./logo/Group 627.png": 258,
	"./logo/Group 629.png": 1307,
	"./logo/Group 630.png": 8283,
	"./logo/Group 631.png": 8777,
	"./newbgdd.jpg": 2202,
	"./online interactive desk.jpg": 3533,
	"./panel/65panel3.png": 1234,
	"./panel/6d29e285da0cb0450ca8367741acf028.jpg": 2159,
	"./panel/75di.png": 4933,
	"./panel/75head.jpg": 9759,
	"./panel/85.jpg": 8838,
	"./panel/98di.png": 2107,
	"./panel/IO-port-65panel2.png": 1571,
	"./panel/p1-65panel4.jpg": 4357,
	"./panel/p2-65panel4.jpg": 116,
	"./panel/p3-65panel4.jpg": 826,
	"./panel/p4-65panel4.jpg": 7955,
	"./panel/single-meeting65panel1.jpg": 1279,
	"./panellap1.png": 8939,
	"./panellap2.png": 3410,
	"./panelpic11.png": 89,
	"./panelpic22.png": 873,
	"./panelpic33.png": 4341,
	"./premiumSupport.jpg": 4625,
	"./productpanel11.png": 6094,
	"./productpanel22.png": 661,
	"./productpanel33.png": 7887,
	"./productpanel44.png": 9813,
	"./sactin gps tracking.png": 2993,
	"./sactin-logo.jpg": 255,
	"./sactin.png": 452,
	"./sactinboy.png": 565,
	"./slider2.jpg": 6728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;